import AnonAccountModal from "./AnonAccountModal";

export default AnonAccountModal;
